<form [formGroup]="form">
    <div class="row col-xs-12 log_sch">
        <!-- Rendering the elements based on filterTemplate json -->
        <div *ngFor="let template of templateSource" [class]="template.isVisible ? template.class : ''">
            <div *ngIf="!!template.type"></div>
            <!-- Text Box -->
            <div *ngIf="template.type === 'label' && template.isVisible" class="row no-margin col-sm-12 form-group">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label>{{template.labelName}}</label>
                </div>
                <div [class]="template.valueClass ? template.valueClass : 'col-md-6'">
                    <span class="margin-right-5">:</span>
                    <label *ngIf="template.labelText" class="padding-left-10"
                        [title]="template.labelText">{{template.labelText}}</label>
                </div>
            </div>
            <div *ngIf="template.type === 'input' && template.isVisible" class="col-sm-12 form-group">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label for="{{template.id}}">{{template.labelName}}<i *ngIf="template.showAsterisk"
                            class="fa fa-asterisk"></i></label>
                </div>
                <div class="srch_field" [ngClass]="[template.elemClass ? template.elemClass : 'col-md-6']">
                    <input pInputText [id]="template.id" [type]="template.inputType"
                        [title]="template.tooltip ? template.tooltip : form.value[template.id]"
                        [formControlName]="template.id"
                        [class]="'form-control ' + (template.elemClass ? template.elemClass : '')"
                        [minlength]="template.min" [maxlength]="template.max" [readonly]="template.isReadOnly"
                        [min]="template.min" [max]="template.max" (blur)="onBlurInputText(template)"
                        (keyup.enter)="onEnterKeyUp(template)" (input)="onChangeInputText($event)">
                    <i *ngIf="template.isHelper" class="fa fa-search" (click)="onClickHelper(template)"></i>
                    <!-- <span class="input-has-error" *ngIf="form.get(template.id).hasError('required')">
            This field is required.
          </span> -->
                    <span class="input-has-error" *ngIf="form.get(template.id).hasError('pattern')"
                        [title]="template.error_message.pattern">
                        {{template.error_message.pattern}}
                    </span>
                    <span class="input-has-error" *ngIf="form.get(template.id).hasError('email')">
                        Invalid Email(eg: abc@xyz.com)
                    </span>
                    <span class="input-has-error" *ngIf="form.get(template.id).hasError('minlength')">
                        Should contain atleast {{template.min}} characters
                    </span>
                    <span class="input-has-error"
                        *ngIf="template.validations && template.validations.length && form.get(template.id).hasError('maxlength')">
                        Should contain maximum {{template.max}} characters
                    </span>
                    <span class="input-has-error" *ngIf="form.get(template.id).hasError('min')"
                        [title]="template.error_message.pattern">
                        {{template.error_message.pattern}}
                    </span>
                    <span class="input-has-error" *ngIf="form.get(template.id).hasError('max')"
                        [title]="template.error_message.pattern">
                        {{template.error_message.pattern}}
                    </span>
                </div>
                <!-- <div *ngIf="form.get(template.id).hasError('pattern')">
          Pattern Not valid
        </div> -->
            </div>

            <!-- Dropdown -->
            <div *ngIf="template.type === 'drop' && template.isVisible" class="col-sm-12 form-group padddin-top-10">
                <div class="col-md-6">
                    <label for="{{template.id}}">{{template.labelName}}<i *ngIf="template.validations.length"
                            class="fa fa-asterisk"></i></label>
                </div>
                <div class="col-md-6">{{template.template}}
                    <p-dropdown [id]="template.id" [options]="template.filteredData" [formControlName]="template.id"
                        [style]="{'width':'100%'}" [optionLabel]="template.displayField"></p-dropdown>
                </div>
            </div>

            <!-- File-Upload -->
            <div *ngIf="template.type === 'file' && template.isVisible" class="col-sm-12 form-group padddin-top-10">
                <div class="col-md-6">
                    <label for="{{template.id}}">{{template.labelName}}<i *ngIf="template.validations.length"
                            class="fa fa-asterisk"></i></label>
                </div>
                <div class="col-md-6 dwn_up">
                    <a class="cursor-pointer">
                        <i data-toggle="tooltip" title="Upload" id="upload" class="fa fa-upload"
                            (click)="onClickUpload($event, template)"></i>
                        <i data-toggle="tooltip" title="Clear" id="clear" style="float: right;" class="fa fa-times"
                            (click)="onClickUpload($event, template)"></i>
                        <i data-toggle="tooltip" title="Download" id="download" style="float: right"
                            class="fa fa-download" (click)="onClickUpload($event, template)"></i></a>
                </div>
            </div>

            <!-- Date Picker -->
            <div *ngIf="template.type === 'picker' && template.isVisible"
                class="form-group calender input-group col-sm-12">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label for="{{template.id}}">{{template.labelName}}<i
                            *ngIf="template.showAsterisk || template.validations.length"
                            class="fa fa-asterisk"></i></label>
                </div>
                <div [class]="template.elemClass ? template.elemClass : 'col-md-6'">
                    <app-date-time-picker [configs]="template" [formGroup]="form"
                        (onSelect)="onSelect($events, template)" (afterPickerOpened)="onAfterPickerOpened(template)">
                    </app-date-time-picker>
                </div>
            </div>

            <!-- Checkbox -->
            <div *ngIf="template.type === 'checkbox' && template.isVisible" class="form-group">
                <div class="input-group col-sm-12">
                    <div class="col-md-6">
                        <label for="{{template.id}}">{{template.labelName}}<i *ngIf="template.validations.length"
                                class="fa fa-asterisk"></i></label>
                    </div>
                    <div class="col-md-6">
                        <p-checkbox [id]="template.id" [formControlName]="template.id" [id]="template.id"
                            (click)="onSelectCheckbox(template)" [binary]="template.isBinary"></p-checkbox>
                    </div>
                </div>
            </div>

            <!-- Search field -->
            <!-- <label class="control-label col-sm-12"></label> -->
            <div *ngIf="template.type === 'search' && template.isVisible"
                class="input-group col-sm-12 form-group auto_complete">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label for="{{template.id}}">{{template.labelName}}<i *ngIf="template.showAsterisk"
                            class="fa fa-asterisk"></i></label>
                </div>
                <div [class]="template.elemClass ? template.elemClass : 'col-md-6'">
                    <app-auto-complete [datasource]="template.filteredData" [configs]="template" [formGroup]="form">
                    </app-auto-complete>
                </div>
            </div>
            <!-- Radio button -->
            <div *ngIf="template.type === 'radio' && template.isVisible" class="form-group report_rad">
                <label *ngIf="template.labelName" class="control-label col-sm-12">{{template.labelName}}</label>
                <div class="row">
                    <span class="col-sm-5 radio ui-float-label" *ngFor="let radio of template.radioGroup">
                        <label class="container3" for="{{radio.id}}">{{radio.labelName}}<i
                                *ngIf="template.validations.length" class="fa fa-asterisk"></i></label>
                        <input type="radio" [id]="radio.id" [name]="template.groupName" [value]="radio.value"
                            [formControlName]="template.groupName" (click)="onSelectRadio(radio)">
                        <span class="checkmark"></span>
                    </span>
                </div>
            </div>

            <!-- Multi select -->
            <div *ngIf="template.type === 'multiselect' && template.isVisible"
                class="form-group report_rad row no-margin">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label *ngIf="template.labelName" class="control-label col-sm-12">{{template.labelName}}
                        <span *ngIf="template.showCount"
                            style="padding-left: 5px;">({{template.datasource.length}})</span>
                        <i *ngIf="template.validations.length" class="fa fa-asterisk"></i></label>

                </div>
                <div [class]="template.elemClass ? template.elemClass : 'col-md-6'">
                    <app-multi-select [list]="template.datasource" [formGroup]="form" [configs]="template"
                        (change)="onChangeMultiSelect($event, template)"></app-multi-select>
                </div>
            </div>

            <!-- Text area -->
            <div *ngIf="template.type === 'textarea' && template.isVisible" class="form-group report_rad"
                [class]="template.textClass ? template.textClass : ''">
                <div [class]="template.labelClass ? template.labelClass : 'col-md-6'">
                    <label *ngIf="template.labelName" class="control-label col-sm-12">{{template.labelName}}<i
                            *ngIf="template.validations.length" class="fa fa-asterisk"></i></label>
                </div>
                <div [class]="template.elemClass ? template.elemClass : 'col-md-6'">
                    <textarea class="text_area" rows="2" [cols]="template.cols ? template.cols : 30" pInputTextarea
                        autoResize="autoResize" [formControlName]="template.id" [attr.disabled]="template.isReadOnly"
                        [attr.placeholder]="template.placeholder"></textarea>
                </div>
            </div>

            <!-- Timer -->
            <div *ngIf="template.type === 'timer' && template.isVisible" class="col-sm-6 form-group report_rad">
                <div class="col-md-6">
                    <label *ngIf="template.labelName" class="control-label col-sm-12">{{template.labelName}}<i
                            *ngIf="template.validations.length" class="fa fa-asterisk"></i></label>
                </div>
                <div class="col-md-6">

                    <button>Start</button>
                </div>
            </div>

            <div *ngIf="template.type === 'buttonEvent' && template.isVisible" class="align-right src_btn">
                <!-- Button -->
                <button *ngIf="template.validateForm" (click)="onClick(template)" pButton type="button"
                    [class]="'ui-button-success ' + (template.buttonClass ? template.buttonClass : '')"
                    [label]="template.controlName" [disabled]="form.invalid || !!template.isDisabled"></button>
                <button *ngIf="!template.validateForm" (click)="onClick(template)" pButton type="button"
                    [class]="'ui-button-success ' + (template.buttonClass ? template.buttonClass : '')"
                    [label]="template.controlName" [disabled]="template.isDisabled"></button>
            </div>

            <div *ngIf="template.type === 'button' && template.isVisible"
                [ngClass]="{'src_btn filter-search-btn' : template.isSearchBtn, 'align-right src_btn' : !template.isSearchBtn }">
                <button pButton type="button" [label]="template.buttonName" class="ui-button-success"
                    (click)="onSubmitFilterCriteria(form.value,templateSource)" [disabled]="form.invalid"></button>
                <button *ngIf="configs && configs['showReset']" pButton type="button" label="Reset"
                    class="ui-button-success align-left" (click)="onReset(form.value,templateSource)"></button>
            </div>
        </div>
    </div>
</form>